module.exports = __webpack_public_path__ + "img/FIRMA_DOCUMENTOSWEB.3572c654.svg";